import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { getAppTabs, getOwningTab } from 'helpers/appNavigation';
import { callNative } from 'helpers/nativeApp';
import AppIcon from './AppIcon';
import styles from './NativeApp.module.scss';

const tapFeedback = () =>
  callNative('Haptics', 'impact', { style: 'LIGHT' }).catch(() => {});

const formatBadge = (count) => (count > 99 ? '99+' : String(count));

/**
 * The app's bottom tab bar: Jobs · Messages · Applications · Profile for
 * freelancers, Projects · Post a project · Messages · Account in client
 * mode. Tab sets and where it shows live in helpers/appNavigation.
 */
const AppTabBar = () => {
  const { pathname } = useLocation();
  const user = useSelector((state) => state.auth.user);
  const unreadMessages = useSelector((state) => state.messages.unreadMessages);

  const tabs = getAppTabs(user);
  if (!tabs.length) return null;

  const activeTab = getOwningTab(pathname, user);
  const badges = { unreadMessages };

  return (
    <nav className={styles.tabBar} aria-label="App tabs" data-app-tab-bar>
      {tabs.map((tab) => {
        const active = activeTab && activeTab.id === tab.id;
        const count = tab.badge ? badges[tab.badge] || 0 : 0;
        return (
          <Link
            key={tab.id}
            to={tab.path}
            className={
              active ? `${styles.tab} ${styles.tabActive}` : styles.tab
            }
            aria-current={active ? 'page' : undefined}
            onClick={tapFeedback}
          >
            <span className={styles.tabIcon}>
              <AppIcon name={tab.icon} />
              {count > 0 && (
                <span className={styles.tabBadge}>
                  {formatBadge(count)}
                  <span className={styles.visuallyHidden}> unread</span>
                </span>
              )}
            </span>
            <span className={styles.tabLabel}>{tab.label}</span>
          </Link>
        );
      })}
    </nav>
  );
};

export default AppTabBar;
